/* eslint-disable jsx-a11y/iframe-has-title */
import {
    Col,
    Layout, Modal, Row
} from "antd";
import React, { useState } from "react";
import "./Videos.less";
const { Content } = Layout;

export const VideosPage = (props) => {
    const [isTutorialModalVisible, setIsTutorialModalVisible] = useState(false);
    const [tutorialType, setTutorialType] = useState("");
    const [tutorialUrl, setTutorialUrl] = useState("");

    const handleTutorial = (tutorial_url) => {
        setTutorialType('video');
        setTutorialUrl(`https://player.vimeo.com/video/${tutorial_url}?autoplay=1&title=0&byline=0&portrait=0`);
        setIsTutorialModalVisible(true);
    };

    return (
        <Content className="site-body-layout">
            <section className="loationFilter pt-3">
                <Row gutter={16}>
                    <Col>
                        <div className="videoCard">
                            <div className="videoInnerCard" onClick={() => handleTutorial('636106582')}>
                                <div className="videoIcon"></div>
                            </div>
                            <div className="mx-3 my-2 py-2">What to observe on keeping yourself clean?</div>
                        </div>
                    </Col>
                    <Col>
                        <div className="videoCard">
                            <div className="videoInnerCard" onClick={() => handleTutorial('636107212')}>
                                <div className="videoIcon"></div>
                            </div>
                            <div className="mx-3 my-2 py-2">How to do cleaning for your personal space & equipment</div>
                        </div>
                    </Col>
                    <Col>
                        <div className="videoCard">
                            <div className="videoInnerCard" onClick={() => handleTutorial('636105380')}>
                                <div className="videoIcon"></div>
                            </div>
                            <div className="mx-3 my-2 py-2">How to do cleaning for customer vehicles, construction or delivery vehicles?</div>
                        </div>
                    </Col>
                    <Col>
                        <div className="videoCard">
                            <div className="videoInnerCard" onClick={() => handleTutorial('636105307')}>
                                <div className="videoIcon"></div>
                            </div>
                            <div className="mx-3 my-2 py-2">How to do cleaning for customer high touch areas properly?</div>
                        </div>
                    </Col>
                    <Col>
                        <div className="videoCard">
                            <div className="videoInnerCard" onClick={() => handleTutorial('636104936')}>
                                <div className="videoIcon"></div>
                            </div>
                            <div className="mx-3 my-2 py-2">How to clean your kitchen area?</div>
                        </div>
                    </Col>
                    <Col>
                        <div className="videoCard">
                            <div className="videoInnerCard" onClick={() => handleTutorial('636104478')}>
                                <div className="videoIcon"></div>
                            </div>
                            <div className="mx-3 my-2 py-2">How to clean a washroom area?</div>
                        </div>
                    </Col>
                    <Col>
                        <div className="videoCard">
                            <div className="videoInnerCard" onClick={() => handleTutorial('636104209')}>
                                <div className="videoIcon"></div>
                            </div>
                            <div className="mx-3 my-2 py-2">How to clean surface, floor etc.</div>
                        </div>
                    </Col>
                </Row>
                {isTutorialModalVisible ?
                    <Modal
                        centered
                        
                        footer={null}
                        width={690}
                        height={500}
                        wrapClassName="viewTutorialPop"
                        // eslint-disable-next-line react/jsx-no-duplicate-props
                        visible={isTutorialModalVisible}
                        onCancel={() => {
                            setTutorialType(null);
                            setTutorialUrl(null);
                            setIsTutorialModalVisible(false);
                        }}
                    >
                        <div className="text-center text-dark px-1 pb-4 w-50 mx-auto">
                        </div>
                        <div>
                            <iframe src={tutorialUrl} width="100%" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                        </div>

                    </Modal> : <></>}
            </section>
        </Content>
    );
};
